import React, { useState, useEffect } from 'react';

const TestAdminMessages = () => {
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    testAdminMessages();
  }, []);

  const testAdminMessages = async () => {
    try {
      // Check tokens
      const token = localStorage.getItem('token');
      const adminToken = localStorage.getItem('adminToken');
      
      console.log('Token:', token ? token.substring(0, 30) + '...' : 'NONE');
      console.log('AdminToken:', adminToken ? adminToken.substring(0, 30) + '...' : 'NONE');
      
      const finalToken = token || adminToken;
      
      if (!finalToken) {
        setError('No token found in localStorage');
        setLoading(false);
        return;
      }

      // Use relative URL - works on any domain
      const url = '/api/messages/admin/conversations';
      
      console.log('Fetching from:', url);
      console.log('With token:', finalToken.substring(0, 30) + '...');
      
      const response = await fetch(url, {
        headers: {
          'Authorization': `Bearer ${finalToken}`
        }
      });
      
      console.log('Response status:', response.status);
      
      if (response.ok) {
        const data = await response.json();
        console.log('Data received:', data);
        setResult(data);
      } else {
        const errorData = await response.json().catch(() => ({}));
        console.error('Error response:', errorData);
        setError(`HTTP ${response.status}: ${JSON.stringify(errorData)}`);
      }
    } catch (err) {
      console.error('Error:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div style={{padding: '20px'}}>Loading...</div>;
  }

  if (error) {
    return (
      <div style={{padding: '20px', color: 'red'}}>
        <h2>Error</h2>
        <pre>{error}</pre>
      </div>
    );
  }

  return (
    <div style={{padding: '20px', color: 'white', background: '#1a1a2e'}}>
      <h1>Admin Messages Test</h1>
      <h2>Conversations Found: {result ? result.length : 0}</h2>
      <pre style={{background: '#0f0f1e', padding: '20px', borderRadius: '8px', overflow: 'auto'}}>
        {JSON.stringify(result, null, 2)}
      </pre>
      <button onClick={testAdminMessages} style={{marginTop: '20px', padding: '10px 20px'}}>
        Refresh
      </button>
    </div>
  );
};

export default TestAdminMessages;
